import { ENV_BASE_URL } from 'env';

export type TCurrentUrlOptions = {
    encoded?: boolean;
    fullUrl?: boolean;
};

export function getCurrentUrl({
    encoded = true,
    fullUrl = false,
}: TCurrentUrlOptions = {}) {
    const curPath = window.location.pathname;
    const curSearch = window.location.search;
    const curHash = window.location.hash;

    let curUrl = `${curPath}${curSearch}${curHash}`;

    if (fullUrl) {
        curUrl = `${window.location.origin}${curUrl}`;
    }

    if (!encoded) return curUrl;

    return encodeURIComponent(curUrl);
}

export function getLoginUrl() {
    const baseUrl = ENV_BASE_URL;
    const curUrl = getCurrentUrl();

    return `${baseUrl}/login?next=${curUrl}`;
}

export function getTwoFactorVerifyUrl() {
    const baseUrl = ENV_BASE_URL;
    const curUrl = getCurrentUrl();

    return `${baseUrl}/otp/verify-token/?next=${curUrl}`;
}

export function getTwoFactorSetupUrl() {
    const baseUrl = ENV_BASE_URL;
    const curUrl = getCurrentUrl();

    return `${baseUrl}/otp/setup-token/?next=${curUrl}`;
}
